import { getStateStore } from '../../stores';

const state = getStateStore('ipc');

export const initializeStaticImageEvents = () => {
  const staticImageBase64 = localStorage.getItem('staticImageBase64');
  if (staticImageBase64) {
    state.staticImageState.currentState.staticImageBase64 = staticImageBase64;
    state.staticImageState.updateState({ ...state.staticImageState.currentState });
  }
  state.staticImageState.addListener((status) => {
    // only update if the image is smaller than 20MB
    if (status.staticImageBase64.length < 20 * 1024 * 1024) {
      localStorage.setItem('staticImageBase64', status.staticImageBase64);
    }
  });

  let cachedPlayerList = Object.keys(state.playerState.currentState.players);
  state.playerState.addListener((playerState) => {
    // removed players
    const removedPlayers = cachedPlayerList.filter((key) => {
      return !playerState.players[key];
    });
    // console.log('Removed players:', removedPlayers);
    if (removedPlayers.length > 0) {
      const staticImageState = state.staticImageState.currentState;
      removedPlayers.forEach((playerId) => {
        delete staticImageState.players[playerId];
      });
      cachedPlayerList = Object.keys(playerState.players);
      state.staticImageState.updateState(staticImageState);
    }
    cachedPlayerList = Object.keys(playerState.players);
  });
};
